// sockets/index.js
import { adminDashboardListener, userDashboardListener } from './dashboard'
import {
  functionMapListener,
  stepBaseFucntionListner,
} from './functionMapListener'
import { adminMessageListener, messageListener } from './message'
import { getMultiSourceList, multiSourceListener } from './multiSource'

export function initSocketListeners(dispatch, user, caseInformation) {
  functionMapListener(dispatch, user)
  stepBaseFucntionListner(dispatch, user, caseInformation)
  adminMessageListener(dispatch, user)
  messageListener(dispatch, user)
  adminDashboardListener(dispatch, user)
  userDashboardListener(dispatch, user)
  getMultiSourceList(dispatch, user)
  multiSourceListener(dispatch, user)
}
